import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './App.css'

ReactDOM.render(
    <div className="App">
    <React.StrictMode >
        <App />
    </React.StrictMode>,
    </div>,
    document.getElementById('root')
)
